import { render } from "./table-action-dropdown.vue?vue&type=template&id=255a4c3c"
import script from "./table-action-dropdown.vue?vue&type=script&lang=js"
export * from "./table-action-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__